import { HlaWayType } from "../../hla/models/HlaWay";
import {
  booleanOptions,
  generateCraOptions,
  presenceDistanceOptions,
  SelectOption,
} from "../../hla/views/HlaWayDetail/form/utils";
import {
  FacilityType,
  FacilityWidth,
  FlowDirectionType,
  HeavyVehicleFlowType,
  NumberOfLanesType,
} from "@keita/lanepatrol-sdk";

export enum HlaAttributeName {
  Type = "type",
  AverageDailyTraffic = "averageDailyTraffic",
  AverageRoadSpeed = "averageRoadSpeed",
  HeavyVehicleFlow = "heavyVehicleFlow",
  FlowDirection = "flowDirection",
  FacilityType = "facilityType",
  FacilityWidthPerDirection = "facilityWidthPerDirection",
  TramOrTrainRails = "tramOrTrainRails",
  Lit = "lit",
  LightSegregation = "lightSegregation",
  HardSegregation = "hardSegregation",
  RoadLane = "roadLane",
  NumberOfLanes = "numberOfLanes",
  VehicleParking = "vehicleParking",
  SevereHazard = "severeHazard",
  ObjectOrLevelChange = "objectOrLevelChange",
  Sidewalk = "sidewalk",
}

export const hlaAttributeOptions: Partial<
  Record<HlaAttributeName, SelectOption[]>
> = {
  type: Object.values(HlaWayType).map((option) => ({
    translation: `shared:hlaWayType.${option}`,
    value: option,
  })),
  heavyVehicleFlow: generateCraOptions(Object.values(HeavyVehicleFlowType)),
  facilityType: generateCraOptions(Object.values(FacilityType)),
  flowDirection: generateCraOptions(Object.values(FlowDirectionType)),
  facilityWidthPerDirection: generateCraOptions(Object.values(FacilityWidth)),
  lit: booleanOptions,
  tramOrTrainRails: booleanOptions,
  lightSegregation: booleanOptions,
  hardSegregation: booleanOptions,
  roadLane: presenceDistanceOptions,
  numberOfLanes: generateCraOptions(Object.values(NumberOfLanesType)),
  vehicleParking: presenceDistanceOptions,
  sidewalk: presenceDistanceOptions,
  objectOrLevelChange: presenceDistanceOptions,
  severeHazard: presenceDistanceOptions,
};
